import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LoadingSpinner from '../components/LoadingSpinner';

const LineupConfirmationPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleConfirmation = async () => {
      if (!token) {
        setError('Invalid confirmation link');
        return;
      }

      try {
        // The backend endpoint redirects, so we just navigate to it
        // The backend will confirm and redirect to the match detail page
        window.location.href = `/api/lineups/lineup/confirm/${token}`;
      } catch (err: any) {
        setError(err.message || 'Failed to confirm lineup');
      }
    };

    handleConfirmation();
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">Confirmation Failed</h1>
          <p className="text-gray-600 dark:text-gray-400 mb-4">{error}</p>
          <button
            onClick={() => navigate('/dashboard')}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <LoadingSpinner />
        <p className="mt-4 text-gray-600 dark:text-gray-400">Confirming lineup...</p>
      </div>
    </div>
  );
};

export default LineupConfirmationPage;

